import { ObserveRefreshData, Vehicle } from "../../../../../types/observe";
import { audioMix } from "../../../../../utils/sendData";
import "./AudioSwitch.scss";

interface AudioSwitchProps {
  refreshData: ObserveRefreshData | null;
  observeCC: string | null;
  vehicle: Vehicle | null;
  sendData: (msg: object) => void;
  onModalOpen: (message: string) => void;
}

const AudioSwitch = ({
  refreshData,
  observeCC,
  vehicle,
  sendData,
  onModalOpen,
}: AudioSwitchProps) => {
  const audioSwitching = refreshData?.info?.audio_switching;
  const voiceSwitching = refreshData?.info?.voice_switching;
  const sr = observeCC;
  const dt = vehicle?.vehicle_communication_code;
  const isButtonEnabled =
    refreshData?.drive?.monitor_f === "1" && !refreshData?.other_selecting;

  const handleClick = (type: "inside" | "outside" | "center") => {
    if (!sr || !dt) return;

    // 車内音声ボタン
    if (type === "inside") {
      // ON→OFF: mic=0, spk=0
      // OFF→ON: mic=1, spk=0
      const mic = audioSwitching === "1" ? 0 : 1;
      const spk = 0;
      sendData(audioMix(sr, dt, mic, spk));
      return;
    }

    // 車外音声ボタン
    if (type === "outside") {
      // ON→OFF: mic=0, spk=0
      // OFF→ON: mic=2, spk=0
      const mic =
        audioSwitching === "2" ||
        (audioSwitching === "0" && voiceSwitching === "2")
          ? 0
          : 2;
      const spk = 0;
      sendData(audioMix(sr, dt, mic, spk));
      return;
    }

    // センター発声ボタン
    if (type === "center") {
      if (
        audioSwitching !== "1" &&
        audioSwitching !== "2" &&
        voiceSwitching !== "2"
      ) {
        onModalOpen("車内音声または車外音声を選択してください。");
        return;
      }

      // センター発声ON→OFF
      if (voiceSwitching === "1" || voiceSwitching === "2") {
        const spk = 0;
        const mic = audioSwitching === "1" ? 1 : 2;
        sendData(audioMix(sr, dt, mic, spk));
        return;
      } else {
        // センター発声OFF→ON
        const spk = audioSwitching === "1" ? 1 : 2;
        const mic = audioSwitching === "1" ? 1 : 0;
        sendData(audioMix(sr, dt, mic, spk));
        return;
      }
    }
  };

  return (
    <div className="audioSwitchArea">
      <div className="title">音声切替</div>
      <div className="buttonWrapper">
        <button
          className={audioSwitching === "1" ? "active" : ""}
          disabled={!isButtonEnabled}
          onClick={() => handleClick("inside")}
        >
          車内音声
        </button>
        <button
          className={
            voiceSwitching === "1" || voiceSwitching === "2" ? "active" : ""
          }
          disabled={!isButtonEnabled}
          onClick={() => handleClick("center")}
        >
          センター
          <br />
          発声
        </button>
        <button
          className={
            audioSwitching === "2" ||
            (audioSwitching === "0" && voiceSwitching === "2")
              ? "active"
              : ""
          }
          disabled={!isButtonEnabled}
          onClick={() => handleClick("outside")}
        >
          車外音声
        </button>
      </div>
    </div>
  );
};

export default AudioSwitch;
